import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// ASSETS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTrash, faChevronRight, faChevronLeft  } from '@fortawesome/free-solid-svg-icons';

// COMPONNENTS
import SortHeader from "../../../../components/atoms/SortHeader";
import { FormCheck } from 'react-bootstrap';

const TableImporters = ({ openDeletModal, openDownload }) => {

    // 🔥 FILAS QUEMADAS
    const staticRows = [
        {
            id: "IMP0001",
            iniciativa: "La Nacional",
            nombreImportacion: "Uso Mixto",
            levantamiento: "21/02/2025",
            dueno: "Camilo Blanco",
            pais: "México",
            zona: "Monterrey"
        },
        {
            id: "IMP0002",
            iniciativa: "The Crown Cantera",
            nombreImportacion: "The Crown Cantera",
            levantamiento: "21/02/2025",
            dueno: "Nathalia G",
            pais: "México",
            zona: "Ciudad de México"
        },
        {
            id: "IMP0003",
            iniciativa: "Palmez",
            nombreImportacion: "Palmez",
            levantamiento: "21/02/2025",
            dueno: "Arturo P",
            pais: "México",
            zona: "Querétaro"
        }
    ];

    // DESCARGAR
    const downloadTemplate = (rowData) => {
        return (
            <button className="iconButton" onClick={() => openDownload(rowData)}>
                <FontAwesomeIcon icon={faDownload} />
            </button>
        );
    };

    // ELIMINAR
    const deleteTemplate = (rowData) => {
        return (
             <button className="iconButton" onClick={() => openDeletModal(rowData.id)}>
                <FontAwesomeIcon icon={faTrash} />
            </button>
        );
    };

    return (
        <div className="datatable-responsive-demo mt-4 tableImporters">
            <DataTable
                value={staticRows}
                className="p-datatable-striped"
                tableStyle={{ 'table-layout': 'auto' }}
                emptyMessage="No se encontraron datos"
            >
                <Column field="id" header={<SortHeader label="ID" />} />
                <Column field="nombreImportacion" header={<SortHeader label="Nombre de la Importación" />}
                    body={(row) => <a className="anchorBlue">{row.nombreImportacion}</a>}
                />
                <Column field="primeraFechaUso" header={<SortHeader label="Primera fecha de uso" />} />
                <Column field="ultimaFechaUso" header={<SortHeader label="Última fecha de uso" />} />
                <Column field="dueño" header={<SortHeader label="Dueño" />} />
                <Column field="tipo" header={<SortHeader label="Tipo" />} />
                <Column field="valor" header={<SortHeader label="Valor" />} />
                <Column header={<SortHeader label="Estado" />} body={() => <input type="checkbox" />} />
            </DataTable>
            <div className="mt-4 text-right">
                <button className="btn">
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button className="btn">
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    );
}

export default TableImporters;